import { render, staticRenderFns } from "./areaCompany.vue?vue&type=template&id=5b39b7e5&scoped=true&"
import script from "./areaCompany.vue?vue&type=script&lang=js&"
export * from "./areaCompany.vue?vue&type=script&lang=js&"
import style0 from "./areaCompany.vue?vue&type=style&index=0&id=5b39b7e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39b7e5",
  null
  
)

export default component.exports